const de = {
  name: 'Dateiname',
}
export default de;